import { useLocation, useMatch } from "react-router-dom";

function Breadcrumb({ onVariableChange }) {
  const location = useLocation();
  const match = useMatch(location.pathname);

  const pathSegments = location.pathname
    .split("/")
    .filter((segment, index) => segment !== "" && index === 1);

  function getPageName(segment) {
    if (segment == 'job-positions-master-list')
      return 'Positions Master List';
    else if (segment == 'job-positions')
      return 'Job Postings'
    else if (segment == 'edit-job-position')
      return 'Edit Position'
    else if (segment == 'employees-for-onboarding2')
      return 'Employees For Onboarding';
    // Convert segment to a human-readable page name
    const pageName = segment.split("/").pop().replace(/-/g, " ");
    const words = pageName.split(" ");
    const tester = words
      .map((word) => {
        const firstLetterIndex = word.search(/[a-zA-Z]/);

        // If there is no letter in the word, return the word as it is
        if (firstLetterIndex === -1) {
          return word;
        }
        
        // Capitalize the first letter and concatenate the rest of the word
        return (
          word.substring(0, firstLetterIndex) +
          word.charAt(firstLetterIndex).toUpperCase() +
          word.slice(firstLetterIndex + 1)
        );
      })
      .join(" ");
    onVariableChange(tester);
    return tester;
  }
  return (
    <nav aria-label="breadcrumb" className="text-black text-lg font-semibold">
      <ol className="breadcrumb">
        {pathSegments.map((segment, index) => {
          const path = `/${pathSegments.slice(0, index + 1).join("/")}`;
          const isCurrentPage = match.path === path;

          return (
            <li
              key={segment}
              className={`breadcrumb-item${isCurrentPage ? " active" : ""}`}
            >
              {isCurrentPage ? (
                // Current page
                <span>{getPageName(segment)}</span>
              ) : (
                // Link to previous page
                <span>{getPageName(segment)}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumb;
